import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Divider,
} from '@chakra-ui/react';
import React, { ReactNode } from 'react';

interface ICustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  footerContent?: ReactNode;
  size?: string;
  isCentered?: boolean;
  showCloseButton?: boolean;
}

const CustomModal: React.FC<ICustomModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footerContent,
  size = 'xl',
  isCentered = true,
  showCloseButton = true,
  ...props
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size} isCentered={isCentered} {...props}>
      <ModalOverlay bg="rgba(0, 0, 0, 0.6)" backdropFilter="blur(2px)" />
      <ModalContent bg={'background.secondary'} rounded={'xl'}>
        {title && (
          <ModalHeader
            fontSize={'xl'}
            fontWeight={'semibold'}
            fontFamily={'primary'}
            color={'text.primary'}
            bg={'white'}
            borderRadius={'12px 12px 0 0'}
          >
            {title.toUpperCase()}
          </ModalHeader>
        )}
        {showCloseButton && <ModalCloseButton />}
        {showCloseButton && <Divider borderColor={'border.default'} />}
        <ModalBody py={4}>{children}</ModalBody>
        {footerContent && (
          <ModalFooter bg={'white'} borderRadius={'0 0 12px 12px'}>
            {footerContent}
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CustomModal;
